module.exports = __webpack_public_path__ + "static/media/header_laptop.89d7d7bb.png";